import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SendMessageFormService {
  private messageValueChanged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private selectedUsersChanged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get valueChanged(): Observable<boolean> {
    return this.messageValueChanged$.asObservable();
  }

  public get selectedUsersChanged(): Observable<boolean> {
    return this.selectedUsersChanged$.asObservable();
  }

  public get formChanged$(): Observable<boolean> {
    return combineLatest([this.messageValueChanged$.asObservable(), this.selectedUsersChanged$.asObservable()]).pipe(
      map(([messageField, selectedUsers]: [boolean, boolean]) => messageField || selectedUsers),
    );
  }

  public updateValue(value: boolean): void {
    this.messageValueChanged$.next(value);
  }

  public updateSelectedUsersValue(value: boolean): void {
    this.selectedUsersChanged$.next(value);
  }

  public resetFormStatus(): void {
    this.messageValueChanged$.next(false);
    this.selectedUsersChanged$.next(false);
  }
}
